import React from 'react';
import { ShieldCheck, ArrowRight, CheckCircle } from 'lucide-react';

export default function Hero() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-emerald-600 via-emerald-500 to-teal-500 text-white">
      {/* Decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 right-0 bottom-0" 
               style={{
                 backgroundImage: `radial-gradient(circle at center, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                 backgroundSize: '20px 20px'
               }}
          />
        </div>
      </div>
      <div className="absolute -top-24 -right-20 w-96 h-96 bg-emerald-400 rounded-full mix-blend-multiply filter blur-2xl opacity-20 animate-blob" />
      <div className="absolute -bottom-32 -left-20 w-96 h-96 bg-teal-400 rounded-full mix-blend-multiply filter blur-2xl opacity-20 animate-blob animation-delay-2000" />
      
      {/* Background image with overlay */}
      <div 
        className="absolute inset-0 z-0 opacity-10"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1633265486064-086b219458ec?auto=format&fit=crop&q=80")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          mixBlendMode: 'overlay'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left column */}
          <div className="space-y-8">
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium">
              <ShieldCheck className="h-5 w-5 mr-2" />
              Enterprise-grade privacy assessments
            </div>
            
            <h1 className="text-4xl lg:text-4xl font-bold font-montserrat leading-tight">
              AI-Powered Automated Assessments {' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-200 to-teal-200">
                Turbocharge Privacy Compliance
              </span>{' '}
              
            </h1>
            
            <p className="text-xl text-emerald-50">
              Professional privacy risk assessments utilizing GenAI, tailored for small and midsize businesses & 
              delivered through our innovative online platform.
              <div className="space-y-2 mt-4 text-base">
                <span className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-emerald-300 mr-3 flex-shrink-0" />
                  Discover privacy risks and prevent financial penalties
                  <a
                    href="/enforcement"
                    className="ml-2 inline-flex items-center text-emerald-200 hover:text-white transition-colors group/link"
                  >
                    <span className="border-b border-emerald-200 group-hover/link:border-white">View Recent Enforcement Actions</span>
                    <ArrowRight className="ml-1 h-4 w-4 group-hover/link:translate-x-1 transition-transform" />
                  </a>
                </span>
              </div>
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#assessments"
                className="inline-flex items-center justify-center px-6 py-3 bg-white text-emerald-600 rounded-lg font-semibold hover:bg-emerald-50 transition-colors group"
              >
                Get Started
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="/learn-more"
                className="inline-flex items-center justify-center px-6 py-3 border border-white/30 rounded-lg font-semibold hover:bg-white/10 transition-colors"
              >
                Learn More
              </a>
            </div>
          </div>
          
          {/* Right column */}
          <div className="lg:pl-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <h3 className="text-xl font-semibold mb-6">Why Choose TurboPIA?</h3>
              <div className="space-y-4">
                {[
                  'Online end-to-end automated assessment solution',
                  'Identify global privacy risks in minutes not weeks',
                  'GenAI and expert analysis with actionable insights',
                  'Regulator-ready reports to demonstrate due diligence',
                  'Target and mitigate your high-risk activities',
                  'Significant cost savings over traditional methods',
                  'No software to purchase or platform to learn',               
                  'Privacy knowledge or training is not required'         
                ].map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <CheckCircle className="h-5 w-5 text-emerald-300 mr-3 flex-shrink-0" />
                    <span className="text-emerald-50">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}